import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../services/modal.service";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() isOpenModal = false
  @Input() typeBg: string | 'main-bg' | undefined
  @Output() isOpenModalChange: EventEmitter<boolean> = new EventEmitter<boolean>()

  @Input() isCloseButtonHide = false
  @Input() isFull = false

  constructor(
    private modalService: ModalService
  ) {
  }

  ngOnInit() {
    this.modalService.isModalOpen$.subscribe({
      next: (res) => this.isOpenModal = res
    })
  }

  closeModal() {
    this.modalService.closeModal()
    this.isOpenModalChange.emit(false)
  }
}
